module.exports = __webpack_public_path__ + "static/media/news.9889d3b3.svg";